import Image from 'next/image';
import Header from 'widgets/header';
import { getImageBasePath } from 'utils/generics';
import { GlobalStyle } from 'utils/styles';
import { PrimaryButton } from '@acko-tech/building-blocks.ui.button';
import { useRouter } from 'next/router';
import { useContext } from 'react';
import { MPosContext } from 'utils/context';
import { useFetchParams } from 'hooks/useFetchParams';
import {
    Container,
    Wrapper,
    ErrorMessage,
    RootWrapper,
    ButtonWrapper,
} from './styles';
import PlansHeader from 'components/newPlan/plans/header';

interface IProps {
    errorCode?: number;
    errorMessage?: string;
    hideHeader?: boolean;
    showEditDeviceHeader?: boolean;
}

function ErrorPage({
    errorCode,
    errorMessage,
    hideHeader,
    showEditDeviceHeader,
}: IProps) {
    const router = useRouter();
    const { lob } = useFetchParams();
    const { partnerId } = useContext(MPosContext);

    const goToDashboard = () => {
        router.push(`/${lob}/${partnerId || 'oppo'}/dashboard`);
    };

    return (
        <RootWrapper>
            {!hideHeader && <Header />}
            {showEditDeviceHeader && <PlansHeader />}
            <GlobalStyle />
            <Container>
                <Wrapper>
                    <div
                        style={{
                            margin: '30px 0',
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                    >
                        <Image
                            src={getImageBasePath('/images/oopsError.svg')}
                            width={'140px'}
                            height={'140px'}
                        />
                    </div>
                    <ErrorMessage>
                        {errorMessage || 'Oops... Something went wrong.'}
                    </ErrorMessage>
                    {errorCode === 404 && (
                        <ButtonWrapper>
                            <PrimaryButton onClick={goToDashboard}>
                                Go to dashboard
                            </PrimaryButton>
                        </ButtonWrapper>
                    )}
                </Wrapper>
            </Container>
        </RootWrapper>
    );
}

export default ErrorPage;
